import React from 'react';
import {connect} from 'react-redux';
import Main from 'app-ui-componentlibrary/dist/go/components/layout/main';
import {Link} from 'react-router-dom';
import {
  Container,
  Header,
  Loader,
  Icon,
  Segment,
  Button,
  Form,
  Search,
} from 'semantic-ui-react';
import DynamicComponentActions from 'go/actions/dynamicComponent';
import {connectDynamic} from 'go/components/dynamic/dynamicComponent';
import {ContentDispatch} from 'framework';
import ApiActions from 'go/actions/api';
import _ from 'lodash';
import REST from 'go/requests/rest';
import {canViewAdminConsoleTab2, isSPGA} from 'go/security/permissions';
import {getUserEntitiesForEntityType} from 'common/utils';
import {ENTITY_MAP} from 'app-ui-componentlibrary/dist/common/constants';
import {CREATE_FUNDING_OPPORTUNITY} from 'app-ui-componentlibrary/dist/go/components/common/pageTitles';
import {forceJsonResponse, MONO, FLUX} from 'common/utils';
export class FoInitialize extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      entityId: 0,
      entityType: 'fo',
      canUserViewPage: canViewAdminConsoleTab2(this.props.auth.permissions),
      isUsrSPGA: isSPGA(this.props.auth.permissions),
      draftId: null,
    };
  }

  createFoDraftEntity = async () => {
    const {grantProgram, context, disaster, foName, jwt} = this.props;
    const program = _.find(
      context.programs,
      (program) => program.programName === grantProgram
    );
    const [disasterNumber, declarationType, disasterState] = disaster.split('-');

    let payloadToSend = {
      programId: program.programId,
      payload: {
        foName: foName,
        disasterNumber: disasterNumber,
        disasterType: declarationType,
        disasterState: disasterState,
        isDisasterFO: program.isDisasterProgram,
        hasGracePeriod: 'Yes',
      },
    };

    return await REST.fundingOpportunity
      .createFundingOpportunityDraft(jwt, payloadToSend)
      .then((response) => response.json())
      .then((res) => {
        if (res) {
          this.setState((prevState) => ({
            ...prevState,
            draftId: res.draftFundingOpportunityId,
          }));
          return res;
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  handleSubmit = () => {
    this.createFoDraftEntity().then((res) =>
      this.props.history.push(
        '/fundingOpportunity/draft/' + res.draftFundingOpportunityId
      )
    );
  };

  componentDidMount() {
    const {entityType, entityId, canUserViewPage, isUsrSPGA} = this.state;
    let configType = 'entityEdit';
    let configId = 'foInitiation';
    let {getConfig} = this.props;
    const {postDynamicData, saveEntitySessionData} = this.props;

    getConfig(this.props.jwt, entityType, entityId, configType, configId)
      .then(async (res) => {
        this.setState({config: res.payload});
        if (res) {
          let data = {};
          let config = res.payload;
          this.props.init(config, data, {
            apiCall: postDynamicData,
          });

          if (canUserViewPage) {
            REST.program
              .getAllPrograms()
              .then((res) => res.json())
              .then((res) => {
                if (res) {
                  let programData = res
                    .filter((item) => item.programStatusId === 76)
                    .map((item) => {
                      return {
                        displayName: item.programName,
                        programName: item.programName,
                        programId: item.programId,
                        isDisasterProgram: item.disasterFlag,
                      };
                    });
                  if (isUsrSPGA) {
                    const programIds = getUserEntitiesForEntityType(
                      this.props.auth.permissions,
                      ENTITY_MAP.PROGRAM.code
                    ).map((programId) => parseInt(programId));

                    programData = programData.filter((item) => {
                      return _.find(programIds, (val) => val === item.programId);
                    });
                  }
                  programData = _.sortBy(programData, [(program) => program.programName]);
                  saveEntitySessionData('context.programs', programData);
                  this.setState({
                    programData,
                  });
                }
              })
              .catch((error) => console.log(error));
          }
          return;
        }
      })
      .catch((error) => console.log(error));
  }

  componentDidUpdate(prevProps) {
    if (
      !_.isEqual(prevProps.grantProgram, this.props.grantProgram) ||
      !_.isEqual(prevProps.disaster, this.props.disaster)
    ) {
      this.refreshData();
    }
  }

  refreshData() {
    document.title = CREATE_FUNDING_OPPORTUNITY;
    const {grantProgram, disaster, saveEntitySessionData} = this.props;
    const {programData} = this.state;

    if (grantProgram) {
      let disasterFlag = _.find(programData, {
        programName: grantProgram,
      }).isDisasterProgram;
      saveEntitySessionData('sessionData.isDisasterProgram', disasterFlag);
    } else {
      saveEntitySessionData('sessionData.isDisasterProgram', null);
    }

    if (disaster) {
      const [disasterNumber, declarationType, disasterState] = disaster.split('-');
      const disasterHeader = {
        disasterNumber,
        declarationType,
        disasterState,
      };
      saveEntitySessionData('context.disasterHeader', disasterHeader);
      REST.disaster
        .getDeclarationSummary(disasterHeader)
        .then((res) => forceJsonResponse(res, MONO))
        .then((res) => {
          saveEntitySessionData('context.disasterSummary', res);
        })
        .catch((error) => console.error(error));
    }
  }

  render() {
    const {config, context, data, dynamicComponent} = this.props;
    return !_.isEmpty(this.props.context.programs) ? (
      <Main>
        <Container id="foInit">
          <Header as="h1">Create funding opportunity</Header>
          <Segment>
            <React.Fragment>
              <div ref={this.handleContextRef}>
                {_.get(config, 'payload') ? (
                  <ContentDispatch
                    className="contentDispatch"
                    config={config.payload}
                    data={data}
                    context={context}
                    dynamicComponent={dynamicComponent}
                    handleSubmit={this.handleSubmit}
                  />
                ) : (
                  <Loader active inline="centered" />
                )}
              </div>
              <br />
              <Button
                color={'blue'}
                id={'id'}
                className={''}
                value={'value'}
                type={'type'}
                onClick={this.handleSubmit}
                disabled={
                  _.get(dynamicComponent, ['validationErrors', 'allValid'], false) ===
                  false
                }
                width={'medium'}
              >
                {'Create funding opportunity'}
              </Button>
              <br />
              <br />
              <Link to="/">
                <Icon name="cancel" />
                Cancel
              </Link>
              <br />
              <br />
            </React.Fragment>
          </Segment>
          <br />
        </Container>
      </Main>
    ) : (
      <Loader active>Loading...</Loader>
    );
  }
}

export const mapStateToProps = (state) => {
  const {config, data, context, sessionData} = state.dynamicComponent;
  return {
    data,
    config,
    context,
    grantProgram: _.get(sessionData, 'grantProgram'),
    disaster: _.get(sessionData, 'disaster'),
    foName: _.get(sessionData, 'foName'),
    dynamicComponent: state.dynamicComponent,
    jwt: state.auth.token,
    auth: state.auth,
    userEntities: _.get(state, 'userEntities.entitiesData'),
    toggles: state.toggles.toggles,
  };
};

export const mapDispatchToProps = (dispatch) => ({
  init: (config, data, serviceCall) =>
    dispatch(DynamicComponentActions.init(config, data, serviceCall)),

  getConfig: (jwt, entityType, entityId, configType, configId) => {
    let action = ApiActions.config.getConfig(
      jwt,
      entityType,
      entityId,
      configType,
      configId
    );
    const res = dispatch(action);
    return res;
  },
  postDynamicData: (payload, token) => {
    const data = payload.data ? payload.data : payload;
    const dataPayload = JSON.stringify(_.omit(data, ['version']));
    let action = ApiActions.dynamicData.postData(token, dataPayload);
    const res = dispatch(action);
    return res;
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(connectDynamic(FoInitialize));
